/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CategoryPayloadModel model module.
 * @module model/CategoryPayloadModel
 * @version v1.0.0
 */
class CategoryPayloadModel {
    /**
     * Constructs a new <code>CategoryPayloadModel</code>.
     * @alias module:model/CategoryPayloadModel
     * @param name {String} Name (required)
     */
    constructor(name) { 
        
        CategoryPayloadModel.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>CategoryPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CategoryPayloadModel} obj Optional instance to populate.
     * @return {module:model/CategoryPayloadModel} The populated <code>CategoryPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryPayloadModel();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * Description
 * @member {String} description
 */
CategoryPayloadModel.prototype['description'] = undefined;

/**
 * Name (required)
 * @member {String} name
 */
CategoryPayloadModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
CategoryPayloadModel.prototype['seq'] = undefined;






export default CategoryPayloadModel;

